import { useState } from "react";
import { Brain, X, ArrowSquareOut } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { errDetail } from "@/lib/api";
import { t } from "@/lib/i18n";

export const MemoryChip = ({ memories }) => {
  const [open, setOpen] = useState(false);
  const [removed, setRemoved] = useState([]);
  const list = (memories || []).filter((m) => !removed.includes(m.id));
  if (!list.length) return null;
  const forget = async (m) => {
    if (!window.confirm(`Forget this memory?\n"${m.snippet}"`)) return;
    try { await api.delete(`/memories/${m.id}`); setRemoved((r) => [...r, m.id]); toast.success("Memory deleted"); }
    catch (e) { toast.error(errDetail(e)); }
  };
  return (
    <div className="mt-1.5">
      <button data-testid="memories-used-chip" onClick={() => setOpen(!open)}
        className="flex items-center gap-1 text-[11px] font-medium text-purple-700 bg-purple-50 border border-purple-100 rounded-full px-2 py-0.5 hover:bg-purple-100 transition-colors">
        <Brain size={11} /> used {list.length} memor{list.length > 1 ? "ies" : "y"}
      </button>
      {open && (
        <div data-testid="memories-used-list" className="mt-1.5 space-y-1">
          {list.map((m) => (
            <div key={m.id} className="flex items-start gap-1.5 bg-gray-50 border border-gray-200 rounded px-2 py-1.5 text-[11px]">
              <span className="uppercase font-bold text-[9px] bg-gray-200 text-gray-600 rounded px-1 py-px shrink-0 mt-px">{m.scope}</span>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-gray-800 truncate">{m.key}{m.auto ? " · auto" : ""}</div>
                <div className="text-gray-600">{m.snippet}</div>
              </div>
              <Link to="/memory" data-testid={`memory-used-open-${m.id}`} className="text-gray-400 hover:text-blue-600 p-0.5"><ArrowSquareOut size={12} /></Link>
              <button data-testid={`memory-used-forget-${m.id}`} onClick={() => forget(m)} title={t("memory.dont_use", "Don't use this")} className="text-gray-400 hover:text-red-600 p-0.5"><X size={12} /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
